import { Component, OnInit } from '@angular/core';
import { ItemsService } from '../items.service';
import { Item } from '../models/item.model';
import { DataTableDirective } from '../../../shared/directives/data-table.directive';
import { FormBuilder, Validators } from '@angular/forms';
import { ColumnConfig } from '../../../shared/models/column-config.model';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '../../../shared/services/title.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../shared/services/page-state-manager.service';
import { AuthService } from '../../../shared/services/auth.service';


@Component({
  selector: 'app-items-list',
  templateUrl: '../../../shared/templates/data-table.component.html',  
  standalone: false
})
export class ItemsListComponent extends DataTableDirective<Item> implements OnInit {
  
  modelName = 'Authorised Item';
  columns: ColumnConfig[] = [];  
  
  constructor(
    itemsService: ItemsService, 
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      itemsService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }

  override ngOnInit(): void {
    this.columns = [
      { 
        name: 'name', 
        label: 'Name', 
        inputType: 'text',
        validators: [Validators.required], 
        errorMessages: { required: 'Name is required' } 
      },    
    ];
    super.ngOnInit();
  }
}
